import { Outlet, useLocation } from "react-router-dom";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import css from './style.module.css'; // Import the CSS module

export default function LayOuts() {
  const location = useLocation();

  // Paths where only the Outlet is displayed
  const footerOnlyPaths = ["/vendorlogin", "/otp", "/forgetpassword", "/", "/login/callback"];

  return (
    footerOnlyPaths.includes(location.pathname) ? (
      <div className={css.centeredLayout}>
        <div className={css.contentContainer}>
          <Outlet />
        </div>
        <Footer />
      </div>
    ) : (
      <section className="container-fluid p-0">
        <div className="row p-0 m-0" style={{ minHeight: "100vh" }}>
          <NavBar />
          <div
            className="d-flex flex-column"
            style={{
              marginLeft: "70px", // Base collapsed width
              minHeight: "100vh",
              width: "calc(100% - 70px)",
              transition: "margin-left 0.3s ease-in-out, width 0.3s ease-in-out"
            }}
            id="main-content"
          >
            <div style={{ flex: 1, padding: "20px" }}>
              <Outlet />
            </div>
            <Footer />
          </div>
        </div>
      </section>
    )
  );
}